import { render, staticRenderFns } from "./TAddMsps.vue?vue&type=template&id=53712856&"
import script from "./TAddMsps.vue?vue&type=script&lang=js&"
export * from "./TAddMsps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports